import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { IHlroomFirstViewModel } from '@sky-it-video/video-hlroom-design-system';

import HtmlWrapper from '../html-wrapper/html-wrapper';

const Tg24roomMainWrapper = React.lazy(() => import('./tg24room-main'));

const DynamicTg24roomMain: React.FC<any> = ({ model = {}, children = null }) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <Tg24roomMainWrapper {...model} />
  </Suspense>
);

DynamicTg24roomMain.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  model: PropTypes.any,
};

/**
 * You need to specify default props to be derived from web-component attributes
 */
DynamicTg24roomMain.defaultProps = {
  children: null,
  model: {} as IHlroomFirstViewModel,
};

export default DynamicTg24roomMain;
